// extracted by mini-css-extract-plugin
export default {"root":"ButtonPlus-modules__root__CRbE0","icon":"ButtonPlus-modules__icon__EhiaI","show-keyframe":"ButtonPlus-modules__show-keyframe__Y76Te"};